import { ActionEnum } from '../action.enum';
import { ClassTreeNodeEntry } from '../../models/customizable-class-tree/class-tree-node-entry.model';
import { TranslationCodeView } from '../../models/translation/TranslationCodeView';
import {
  CustomizableClassTreeInternalCodeEnum
} from '../../models/customizable-class-tree/customizable-class-tree-internal-code.enum';

export namespace CustomizableClassTreeAction {

  export class LoadClassTree {
    static readonly type: ActionEnum = ActionEnum.CUSTOMIZABLE_CLASS_TREE_LOAD_TREE;
    constructor(public orgId: string, public treeId: string | null, public treeInternalCode: CustomizableClassTreeInternalCodeEnum | null) {}
  }

  export class ToggleColumn {
    static readonly type: ActionEnum = ActionEnum.CUSTOMIZABLE_CLASS_TREE_TOGGLE_COLUMN;
    constructor(public classId: string) {}
  }

  export class ToggleDragSelection {
    static readonly type: ActionEnum = ActionEnum.CUSTOMIZABLE_CLASS_TREE_TOGGLE_DRAG_SELECTION;
    constructor(
      public classId: string,
      public classEntry?: ClassTreeNodeEntry
    ) {}
  }

  export class StartDrag {
    static readonly type: ActionEnum = ActionEnum.CUSTOMIZABLE_CLASS_TREE_START_DRAG;
    constructor(
      public classId: string,
      public classEntry?: ClassTreeNodeEntry
    ) {}
  }

  export class EndDrag {
    static readonly type: ActionEnum = ActionEnum.CUSTOMIZABLE_CLASS_TREE_END_DRAG;
  }

  export class Drop {
    static readonly type: ActionEnum = ActionEnum.CUSTOMIZABLE_CLASS_TREE_DROP;
    constructor(public parentId: string, public placeBefore: string | null) {}
  }

  export class Delete {
    static readonly type: ActionEnum = ActionEnum.CUSTOMIZABLE_CLASS_TREE_DELETE;
    constructor(public classId: string, public parentId: string) {}
  }

  export class Rename {
    static readonly type: ActionEnum = ActionEnum.CUSTOMIZABLE_CLASS_TREE_RENAME;
    constructor(public classId: string, public nameTranslation: TranslationCodeView) {}
  }

  export class Undo {
    static readonly type: ActionEnum = ActionEnum.CUSTOMIZABLE_CLASS_TREE_UNDO;
  }

  export class Redo {
    static readonly type: ActionEnum = ActionEnum.CUSTOMIZABLE_CLASS_TREE_REDO;
  }

  export class Save {
    static readonly type: ActionEnum = ActionEnum.CUSTOMIZABLE_CLASS_TREE_SAVE;
  }

  export class DeleteTree {
    static readonly type: ActionEnum = ActionEnum.CUSTOMIZABLE_CLASS_TREE_DELETE_TREE;
  }

  export class ResetState {
    static readonly type: ActionEnum = ActionEnum.CUSTOMIZABLE_CLASS_TREE_RESET_STATE;
  }
}
